<template>

<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="14.7724" y="24" width="70.2876" height="52.5217" stroke="black" stroke-width="4"/>
<path d="M84.9439 58.6675L65.6657 39.358L28.5 76.5237" stroke="black" stroke-width="4"/>
<path d="M44.074 61.757L29.4226 47.0818L14 62.5294" stroke="black" stroke-width="4"/>
<circle cx="43.5" cy="38.5" r="5.5" stroke="black" stroke-width="4"/>
</svg>

</template>
